// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__30wBI","boxTitle":"Qualiphy_boxTitle__95xUq","box":"Qualiphy_box__RexJL","toggleWrap":"Qualiphy_toggleWrap__37x-P"};